var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "floor-form" },
    [
      _c(
        "v-btn",
        {
          attrs: {
            loading: _setup.formState.isLoading,
            disabled: _setup.formState.isLoading,
            color: "success"
          },
          on: { click: _setup.onAddFloorForm }
        },
        [_vm._v("Add Floor Form")]
      ),
      _c("v-text-field", {
        attrs: {
          "error-messages": _setup.formState.errors.floorNumber,
          label: "Floor Number",
          dense: "",
          outlined: "",
          "hide-details": "auto"
        },
        model: {
          value: _setup.formState.data,
          callback: function($$v) {
            _vm.$set(_setup.formState, "data", $$v)
          },
          expression: "formState.data"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }